import {useContext} from "react";
import {ModalsProviderContext} from "./ModalsProvider.context";

export default function useModals() {
    return useContext(ModalsProviderContext);
}
